import actions from "actions";
import Pagination from "components/Pagination/TablePagination";
import React, { Component } from "react";
import { connect } from "react-redux";

const labels = [
  "Title",
  "First name",
  "Last name",
  "Hospital",
  "County",
  // "Actions",
];

const { getGroupMembers } = actions;

class StudyGroupUserMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 25,
      search: "",
    };
  }

  loadMembers = () => {
    this.props.loadStudyGroupMembers({
      id: this.props.params.id,
      params: this.state,
    });
  };

  componentDidMount() {
    this.loadMembers();
  }

  onChangePage = (page) => this.setState({ page }, this.loadMembers);

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadMembers, timeout);
    });
  };

  render() {
    const {
      studygroupMembers: { totalPages, data },
    } = this.props;

    const { page, search } = this.state;

    return (
      <div style={{ width: "90%", margin: "auto" }}>
        <div className="container_admin_user">
          <div className="search_admin">
            <input id="search" type="submit" className="validate" />
            <label htmlFor="search">
              <i className="material-icons icon_search">search</i>
            </label>
            <input
              type="search"
              placeholder="Search"
              value={search}
              onChange={(e) => this.handleQueryChange(e.target.value)}
            />
            <i
              className="material-icons icon_close"
              onClick={() => this.handleQueryChange("")}
            >
              close
            </i>
          </div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                {labels.map((label, idx) => (
                  <th key={idx}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map(
                ({ id, title, first_name, last_name, hospital, county }) => (
                  <tr key={id}>
                    <td>{title}</td>
                    <td>{first_name}</td>
                    <td>{last_name}</td>
                    <td>{hospital}</td>
                    <td>{county}</td>
                    {/* <td>Send message</td> */}
                  </tr>
                )
              )}
              <tr></tr>
            </tbody>
          </table>
        </div>
        <div style={{ width: "max-content" }}>
          <Pagination
            onChangePage={this.onChangePage}
            page={page}
            total_pages={totalPages}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroupMembers: state.studygroups.members,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyGroupMembers: (data) => dispatch(getGroupMembers(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserMembers);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserMembers.jsx